/*
 * This model stores the last 10 pages visited, which we'll pass to CAL
 * Thus when analyzing CAL log, we have clearer context about where user have been
 */

'use strict';

var Backbone = require('backbone');

var HistoryModel = Backbone.Model.extend({

	CONST_MAX_PAGE: 10,

	path: [],

	addPath: function (path) {
		if (this.path.length === this.CONST_MAX_PAGE) {
			this.path.shift();
		}
		this.path.push(path);
	},

	getPath: function () {
		return this.path.join(' > ');
	}
});

module.exports = new HistoryModel();



//////////////////
// WEBPACK FOOTER
// ./components/consumerweb-client-error-logger/historyModel.js
// module id = 21
// module chunks = 0